/* The Mint Workshop — header & footer behaviour.
   Drawer, sticky state, live cart count. Degrades to plain links without JS. */
(function () {
  'use strict';

  function initHeader() {
    var hdr = document.querySelector('[data-mw-header]');
    if (hdr && !hdr.dataset.mwReady) {
      hdr.dataset.mwReady = '1';
      var onScroll = function () {
        hdr.classList.toggle('is-stuck', window.scrollY > 8);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    var drawer = document.querySelector('[data-mw-drawer]');
    if (drawer && !drawer.dataset.mwReady) {
      drawer.dataset.mwReady = '1';
      var panel = drawer.querySelector('.mw-drawer__panel');
      var lastFocus = null;

      function open() {
        lastFocus = document.activeElement;
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        var first = panel.querySelector('button, a');
        // Focus the dialog itself, not the first link. Programmatic focus on a
        // link paints a visible focus ring, which read as a red box on the logo.
        if (panel) panel.focus();
        else if (first) first.focus();
      }

      function close() {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        if (lastFocus) lastFocus.focus();
      }

      document.querySelectorAll('[data-mw-drawer-open]').forEach(function (b) {
        b.addEventListener('click', open);
      });
      drawer.querySelectorAll('[data-mw-drawer-close]').forEach(function (b) {
        b.addEventListener('click', close);
      });

      document.addEventListener('keydown', function (e) {
        if (!drawer.classList.contains('is-open')) return;
        if (e.key === 'Escape') { close(); return; }
        if (e.key !== 'Tab') return;
        // Trap focus inside the panel
        var f = panel.querySelectorAll('a[href], button:not([disabled])');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });

      /* Collapsible submenus. Animating to a measured height rather than
         toggling display gives it somewhere to travel; height:auto cannot be
         transitioned. Only one section open at a time keeps the drawer short. */
      drawer.querySelectorAll('[data-mw-sub-toggle]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var wrap = btn.nextElementSibling;
          if (!wrap) return;
          var opening = !wrap.classList.contains('is-open');

          drawer.querySelectorAll('.mw-dnav__wrap.is-open').forEach(function (w) {
            if (w === wrap) return;
            w.style.height = w.scrollHeight + 'px';
            requestAnimationFrame(function () { w.style.height = '0px'; });
            w.classList.remove('is-open');
            var b = w.previousElementSibling;
            if (b) b.setAttribute('aria-expanded', 'false');
          });

          if (opening) {
            wrap.classList.add('is-open');
            wrap.style.height = wrap.scrollHeight + 'px';
            wrap.addEventListener('transitionend', function done(ev) {
              if (ev.propertyName !== 'height') return;
              wrap.style.height = 'auto';           // survive later reflow
              wrap.removeEventListener('transitionend', done);
            });
          } else {
            wrap.style.height = wrap.scrollHeight + 'px';
            requestAnimationFrame(function () { wrap.style.height = '0px'; });
            wrap.classList.remove('is-open');
          }
          btn.setAttribute('aria-expanded', opening ? 'true' : 'false');
        });
      });
    }
  }

  /* Keep the cart bubble honest after add-to-cart happens elsewhere on the page */
  function refreshCart() {
    var nodes = document.querySelectorAll('[data-mw-cart-count]');
    if (!nodes.length) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        nodes.forEach(function (n) {
          n.textContent = cart.item_count;
          n.style.display = cart.item_count > 0 ? '' : 'none';
        });
      })
      .catch(function () { /* leave the server-rendered count in place */ });
  }

  function init() {
    initHeader();
    refreshCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () { setTimeout(init, 40); });
  document.addEventListener('cart:updated', refreshCart);
})();
